import { AttorneyData } from 'src/dtos/applicationData'
import { RenewalData } from 'src/dtos/renewalData'
import { aboutAttorneyPosition } from 'src/constants/application'

export const attorneyFullName = (attorney: AttorneyData) => {
  return [attorney.firstName?.trim(), attorney.lastName?.trim()].join(' ')
}

export const remainingOlderAttorneys = (renewalData: RenewalData) => {
  const olderAttorneys = renewalData?.attorneysSection?.attorneys ?? []

  if(olderAttorneys.length > 0) {
    if(renewalData?.renewalSection?.departingAttorneys && renewalData?.renewalSection?.departingAttorneys.length > 0) {
      const departingAttorneysNames = renewalData.renewalSection.departingAttorneys.map(att => att.attorneyName)
      let remaining: AttorneyData[] = []
      olderAttorneys.forEach(att => {
        if(!departingAttorneysNames.includes(attorneyFullName(att)))
        remaining.push(att)
      })
      return remaining
    } else {
      return olderAttorneys
    }
  } else {
    return []
  }
}

export const allActiveAttorneys = (renewalData: RenewalData) => {
  return [
    ...remainingOlderAttorneys(renewalData),
    ...(renewalData?.renewalSection?.newAttorneys?.map(attorney => ({ ...attorney, isNewAttorney: true })) ?? [])
  ];
};

export const onlyICOCAttorneys = (renewalData: RenewalData) => {
  const allAttorneys = allActiveAttorneys(renewalData)

  if(allAttorneys.length > 0) {
    const ic = aboutAttorneyPosition[1]
    const oc = aboutAttorneyPosition[4]

    return allAttorneys.filter(att => att?.position === ic || att?.position === oc)
  }
  return []
}

export const hasICOCAttorneys = (renewalData: RenewalData) => {
  const icocAttorneys = onlyICOCAttorneys(renewalData)

  return icocAttorneys.length > 0
}

export const isClaimsTriggered = (renewalData: RenewalData) => {
  return (renewalData?.renewalSection?.hasMalPracticeClaims === true && renewalData?.renewalSection?.hasMalPracticeClaimsReported === false) ||
    (renewalData?.renewalSection?.hasMalPracticeBasis === true && renewalData?.renewalSection?.hasMalPracticeBasisReported === false)
}

export const isJudgeClaimsTriggered = (renewalData: RenewalData) => {
  return (renewalData?.judgeRenewalSection?.questions?.hasBeenSubjectOfClaim === true && renewalData?.judgeRenewalSection?.questions?.hasClaimBeenReported === false) ||
    (renewalData?.judgeRenewalSection?.questions?.hasBasisForClaim === true && renewalData?.judgeRenewalSection?.questions?.hasBasisForClaimReported === false)
}